import * as React from "react";
import { Row, Col, Input } from "antd";
import signature from "../../assets/images/signature.png";
import { TPaymentConfirmationPresentationModel } from "../../../presenter/payment/model/PaymentConfirmationPresentationModel";
import {
  PaymentConfirmationConstants,
  Constants
} from "../../../common/Constants";
import Text from "antd/lib/typography/Text";
import TextArea from "antd/lib/input/TextArea";

const DomesticPaymentForm = ({
  paymentConfirmationData,
  translate
}: {
  paymentConfirmationData: TPaymentConfirmationPresentationModel;
  translate: any;
}) => {
  return (
    <React.Fragment>
      <div className="content-container">
        <div className="content-section">
          <div className="content-section-border">
            <Row className={"group-items"}>
              <Text className={"label"}>
                {translate("payment_confirmation_page.sender_name")}
              </Text>
              <TextArea
                rows={3}
                readOnly
                className={"input"}
                value={paymentConfirmationData.senderName}
              />
            </Row>
            <Row className={"group-items"}>
              <Text className={"label"}>
                {translate("payment_confirmation_page.description")}
              </Text>
              <TextArea
                rows={3}
                readOnly
                className={"input"}
                value={paymentConfirmationData.description}
              />
            </Row>
            <Row className={"group-items"}>
              <Text className={"label"}>
                {translate("payment_confirmation_page.receiver")}
              </Text>
              <TextArea
                rows={3}
                readOnly
                className={"input"}
                value={paymentConfirmationData.receiverName}
              />
            </Row>
          </div>
          <div className="content-section-border">
            <Row className={"group-items"} gutter={[8, 8]}>
              <Col lg={12} xs={15}>
                <Text className={"label"}>
                  {translate("payment_confirmation_page.processing_date")}
                </Text>
                <Input
                  readOnly
                  className={"input"}
                  value={paymentConfirmationData.processingDate}
                />
              </Col>
              <Col lg={12} xs={9} className="signature-wrapper">
                <img src={signature} alt="Bank stamp" />
              </Col>
            </Row>
          </div>
        </div>
        <div className="content-section">
          <div className="content-section-emphasize">
            <Row className={"group-items"}>
              <Text className={"label"}>
                {translate("payment_confirmation_page.sender_account")}
              </Text>
              <Input
                readOnly
                className={"input"}
                value={paymentConfirmationData.senderAccount}
              />
            </Row>
            <Row className={"group-items"}>
              <Text className={"label"}>
                {translate("payment_confirmation_page.receiver_account")}
              </Text>
              <Input
                readOnly
                className={"input"}
                value={paymentConfirmationData.receiverAccount}
              />
            </Row>
            {paymentConfirmationData.paymentReferenceVisible ? (
              <Row className={"group-items"}>
                <Text className={"label"}>
                  {translate("payment_confirmation_page.payment_reference")}
                </Text>
                <Input
                  readOnly
                  className={"input"}
                  value={paymentConfirmationData.paymentReference}
                />
              </Row>
            ) : (
              <div />
            )}
            <Row className={"group-items"} gutter={[8, 8]}>
              <Col lg={6} xs={6}>
                <Text className={"label"}>
                  {translate("payment_confirmation_page.currency")}
                </Text>
                <Input
                  readOnly
                  className={"input"}
                  value={PaymentConfirmationConstants.DEFAULT_CURRENCY_UPP}
                />
              </Col>
              <Col
                lg={12}
                xs={paymentConfirmationData.instantPaymentVisible ? 10 : 12}>
                <Text className={"label"}>
                  {translate("payment_confirmation_page.amount")}
                </Text>
                <Input
                  readOnly
                  className={"input"}
                  value={paymentConfirmationData.amount}
                />
              </Col>
              {paymentConfirmationData.instantPaymentVisible && (
                <Col lg={3} xs={4}>
                  <Text className={"label"}>
                    {translate("payment_confirmation_page.instant")}
                  </Text>
                  <Input
                    readOnly
                    className={"input"}
                    value={
                      paymentConfirmationData.instant === Constants.TRUE
                        ? translate(
                            "payment_confirmation_page.instant_payment_yes"
                          )
                        : translate(
                            "payment_confirmation_page.instant_payment_no"
                          )
                    }
                  />
                </Col>
              )}
              <Col
                lg={paymentConfirmationData.instantPaymentVisible ? 3 : 6}
                xs={paymentConfirmationData.instantPaymentVisible ? 4 : 6}>
                <Text className={"label"}>
                  {translate("payment_confirmation_page.urgent")}
                </Text>
                <Input
                  readOnly
                  className={"input"}
                  value={
                    paymentConfirmationData.urgent === Constants.TRUE
                      ? translate("payment_confirmation_page.high_priority_yes")
                      : translate("payment_confirmation_page.high_priority_no")
                  }
                />
              </Col>
            </Row>
          </div>
          {paymentConfirmationData.taxPayerId ? (
            <React.Fragment>
              <div className="content-section-emphasize">
                <Row>
                  <Text className={"content-section-title"}>
                    {translate("payment_confirmation_page.public_income_label")}
                  </Text>
                </Row>
                <Row className={"group-items"} gutter={[8, 8]}>
                  <Col lg={18} xs={24}>
                    <Text className={"label"}>
                      {translate("payment_confirmation_page.tax_payer_id")}
                    </Text>
                    <Input
                      readOnly
                      className={"input"}
                      value={paymentConfirmationData.taxPayerId}
                    />
                  </Col>
                  <Col lg={6} xs={24}>
                    <Text className={"label"}>
                      {translate("payment_confirmation_page.payment_type")}
                    </Text>
                    <Input
                      readOnly
                      className={"input"}
                      value={paymentConfirmationData.paymentType}
                    />
                  </Col>
                </Row>
                <Row
                  className={"group-items"}
                  gutter={[16, 8]}
                  align={"middle"}
                  justify={"space-between"}>
                  <Col xs={24} md={24} lg={11} xl={13} xxl={15}>
                    <Text className={"label"}>
                      {translate("payment_confirmation_page.revenue_type")}
                    </Text>
                    <Input
                      readOnly
                      className={"input"}
                      value={paymentConfirmationData.revenueType}
                    />
                  </Col>
                  <Col xs={24} md={24} lg={13} xl={11} xxl={9}>
                    <Row gutter={[8, 8]}>
                      <Col xs={24} md={24}>
                        <Text className={"label"}>
                          {translate(
                            "payment_confirmation_page.tax_period_label"
                          )}
                        </Text>
                      </Col>
                      <Col xs={24} md={24}>
                        <Row
                          align={"middle"}
                          justify={"space-between"}
                          gutter={[8, 8]}>
                          <Col flex={"30px"}>
                            <Text className={"label"}>
                              {translate("payment_confirmation_page.from")}
                            </Text>
                          </Col>
                          <Col flex={"auto"}>
                            <Input
                              readOnly
                              className={"input"}
                              value={paymentConfirmationData.taxPeriodFrom}
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={24} md={24}>
                        <Row
                          align={"middle"}
                          justify={"space-between"}
                          gutter={[8, 8]}>
                          <Col flex={"30px"}>
                            <Text className={"label"}>
                              {translate("payment_confirmation_page.to")}
                            </Text>
                          </Col>
                          <Col flex={"auto"}>
                            <Input
                              readOnly
                              className={"input"}
                              value={paymentConfirmationData.taxPeriodTo}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>

                <Row className={"group-items"} gutter={[8, 8]}>
                  <Col lg={12} xs={24}>
                    <Text className={"label"}>
                      {translate("payment_confirmation_page.municipality")}
                    </Text>
                    <Input
                      readOnly
                      className={"input"}
                      value={paymentConfirmationData.municipality}
                    />
                  </Col>
                  <Col lg={12} xs={24}>
                    <Text className={"label"}>
                      {translate("payment_confirmation_page.budgetary_unit")}
                    </Text>
                    <Input
                      readOnly
                      className={"input"}
                      value={paymentConfirmationData.budgetaryUnit}
                    />
                  </Col>
                  <Col lg={12} xs={24}>
                    <Text className={"label"}>
                      {translate("payment_confirmation_page.tax_ref_number")}
                    </Text>
                    <Input
                      readOnly
                      className={"input"}
                      value={paymentConfirmationData.taxRefNumber}
                    />
                  </Col>
                </Row>
              </div>
            </React.Fragment>
          ) : null}
        </div>
      </div>
    </React.Fragment>
  );
};

export default DomesticPaymentForm;
